import { EventEmitter } from "../utils/event-emitter";
import { type WallProvider, type WallProviderEvents } from "./wall-provider";

export class WallProviderRemote
  extends EventEmitter<WallProviderEvents>
  implements WallProvider
{
  public destroy(): void {}
  public async fetchMediaUrl(): Promise<void> {}

  public onReset(): void {}
  public onAnalyticsEvent(): void {}
  public onBackgroundMediaVideoCompleted(): void {}
  public onFlyoutClosed(): void {}
  public onFlyoutInteracted(): void {}
  public onFlyoutKeepAlive(): void {}
  public onPostInteracted(): void {}
  public onPostFlyoutDirectActivation(): void {}
  public onPostRequestChange(): void {}
  public onRestingMediaInteracted(): void {}
  public onRestingMediaVideoCompleted(): void {}
  public onScreenMenuClosed(): void {}
  public onScreenMenuOpened(): void {}
}
